import { render, staticRenderFns } from "./SystemHero.vue?vue&type=template&id=741697cd&"
import script from "./SystemHero.vue?vue&type=script&lang=js&"
export * from "./SystemHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports